import { render, staticRenderFns } from "./GeneralPix.vue?vue&type=template&id=08ca92d2"
import script from "./GeneralPix.vue?vue&type=script&lang=js"
export * from "./GeneralPix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports